module.exports = __webpack_public_path__ + "static/media/S2N9-3.27cfb5e1.svg";